module.exports = __webpack_public_path__ + "static/img/jieshao.17ccf10e.png";